import lazy from 'utils/lazy';

export const Checkout = lazy(() => import('./Checkout'));
